module.exports = __webpack_public_path__ + "static/media/transport.4b59e944.svg";